// src/pages/ThankYouPage.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {

    // Redirect to homepage after 5 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer); // Cleanup
  }, [navigate]);

  return (
    <>
      <Header />
        <div className="container" style={{ marginTop: "4rem", bottom: "4rem", height:"80%"}}>
          <div
            className="container"
            style={{ marginBottom: "8rem", marginTop: "4rem" }}
          >
            <div className="steps-container">
              <h2 style={{...styles.title, textAlign:"center"}}>Proces zapisu na spotkanie przebiegł pomyślnie. <br/> Dziękujemy za zaufanie!</h2>
              <ul style={{ ...styles.text, listStyleType: "'✓ '", paddingLeft: '10%' }}>
                <li style={{marginBottom:'1rem'}}>Za chwilę przeniesiemy Cię z powrotem na naszą stronę główną.</li>
                <li>W najbliższym czasie otrzymasz na wskazany przez Ciebie adres e-mail wiadomość z linkiem do spotkania.</li>
              </ul>
            </div>
          </div>
        </div>
      <Footer />
    </>
  );
};

const styles = {
  title: {
    fontSize: '28px',
    marginBottom: '3rem',
    color: 'hsl(274, 53%, 40%)',
  },
  text: {
    fontSize: '18px',
    // marginLeft:
    color: 'hsl(274, 53%, 40%)',
  },
};

export default ThankYouPage;
